import React, { Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';

// Lazy load pages for better performance
const Landing = React.lazy(() => import('./pages/Landing'));
const CompanyProfile = React.lazy(() => import('./pages/CompanyProfile'));
const Payment = React.lazy(() => import('./pages/Payment'));
const Assessment = React.lazy(() => import('./pages/Assessment'));
const Results = React.lazy(() => import('./pages/Results'));
const AdminPanel = React.lazy(() => import('./pages/AdminPanel'));

// Loading fallback component
const LoadingFallback: React.FC = () => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      backgroundColor: 'background.default',
    }}
  >
    <CircularProgress size={48} />
  </Box>
);

const App: React.FC = () => {
  return (
    <Suspense fallback={<LoadingFallback />}>
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<Landing />} />
        <Route path="/company" element={<CompanyProfile />} />
        <Route path="/payment" element={<Payment />} />
        <Route path="/assessment/:token" element={<Assessment />} />
        <Route path="/results/:token" element={<Results />} />

        {/* Admin route */}
        <Route path="/admin" element={<AdminPanel />} />

        {/* Fallback route */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  );
};

export default App;
